'use client';
import { type Context, createContext, useContext } from 'react';
import { usePageInstanceId } from '../../context/PageInstanceIdProvider';
import type { BuilderInterfaceStoreSelectors } from './builder/selectors';
import { useOptionalInterfaceStoreManager } from './runner/InterfaceStoreManagerContext';
import type { RunnerInterfaceStoreSelectors } from './runner/selectors';

type InterfaceStoreContextValue =
  | RunnerInterfaceStoreSelectors
  | BuilderInterfaceStoreSelectors
  | null;

export const InterfacePageStoreContext: Context<InterfaceStoreContextValue> =
  createContext<InterfaceStoreContextValue>(null);

export const InterfaceAppStoreContext: Context<InterfaceStoreContextValue> =
  createContext<InterfaceStoreContextValue>(null);

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters -- required to differentiate between runner and builder
export const useInterfaceStore = <T = RunnerInterfaceStoreSelectors>(): T => {
  const manager = useOptionalInterfaceStoreManager();
  const instanceId = usePageInstanceId();
  const directStore = useContext(InterfacePageStoreContext);
  if (manager) {
    return manager.getStore(instanceId) as T;
  }
  if (!directStore) {
    throw new Error('Missing InterfacePageStoreContext.Provider');
  }
  return directStore as T;
};

export const useInterfaceAppStore = <T = RunnerInterfaceStoreSelectors>(): T => {
  const _useStore = useContext(InterfaceAppStoreContext);
  if (!_useStore) {
    throw new Error('Missing InterfaceAppStoreContext.Provider');
  }
  return _useStore as T;
};
